export default __webpack_public_path__ + "static/media/img_13.6c815009.jpg";